export default ({ axios }) => ({
    update: (id, body) => axios.patch(`/categories/${id}`, body)
})



// WEBPACK FOOTER //
// ./src/api/categories.js